import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Grid, Button, Divider, Typography } from "@material-ui/core";
import { Add, Replay, GetApp } from "@material-ui/icons";

import toJs from "../../../hoc/toJS";
import select from "../../../utils/select";

import ExhibitionInsertModal from "../ExhibitionInsertModal";
import ExhibitionExportModal from "../ExhibitionExportModal";

import {
  getAllExhibition,
  getAllExhibitionByProfileId,
  getFilteredExhibition,
  exportExhibition,
} from "../../../reducer/exhibition/action";

function ExhibitionButton(props) {
  const { getAllExhibition, getAllExhibitionByProfileId, getFilteredExhibition } = props;

  const [inserting, setInserting] = useState(false);
  const [exporting, setExporting] = useState(false);

  let profileId = props.selectedProfileId;
  if (!profileId) profileId = props.profileDetail?.id;

  useEffect(() => {
    if (props.type !== "all" && profileId) getAllExhibitionByProfileId(profileId);
    return false;
  }, []);

  useEffect(() => {
    if (props.type === "all" && props.listFilteredExhibition.length === 0 && !props.isFetching)
      getFilteredExhibition(1, -1, { departmentId: props.department });
  }, []);

  useEffect(() => {
    if (props.type === "all" && !props.isFetching && !props.isFetchingAccepted)
      getFilteredExhibition(1, -1, { departmentId: props.department });
  }, [props.department, getFilteredExhibition]);

  const handleReload = () => {
    if (props.type !== "all") {
      if (profileId) {
        getAllExhibitionByProfileId(profileId);
        props.handleReload();
      }
    } else {
      getFilteredExhibition(1, -1, { departmentId: props.department });
      props.handleReload();
    }
  };
  const handleInsert = () => setInserting(true);

  const handleExport = () => setExporting(true);

  const handleExportData = async (payload) => {
    await props.exportExhibition(payload);
    setExporting(false);
  };

  return (
    <>
      <Grid container>
        <Grid item xs={6}>
          <Typography variant="h5" style={{ lineHeight: "36px" }}>
            Triển lãm
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <div style={{ float: "right" }}>
            <Button variant="outlined" startIcon={<Replay />} onClick={handleReload}>
              Tải lại
            </Button>
            <Button
              variant="contained"
              color="secondary"
              startIcon={<GetApp />}
              style={{ marginLeft: 8 }}
              onClick={handleExport}
            >
              Xuất Excel
            </Button>
            {props.type !== "all" && (
              <Button
                variant="contained"
                color="primary"
                startIcon={<Add />}
                style={{ marginLeft: 8 }}
                onClick={handleInsert}
              >
                Thêm
              </Button>
            )}
          </div>
        </Grid>
      </Grid>
      <Divider style={{ margin: "8px 0" }} />
      <ExhibitionInsertModal inserting={inserting} setInserting={setInserting} setUpdating={props.setUpdating} />
      <ExhibitionExportModal exporting={exporting} setExporting={setExporting} handleExportData={handleExportData} />
    </>
  );
}

const mapStateToProps = (state) => ({
  isFetching: select(state, "exhibitionReducer", "isFetching"),
  isFetchingAccepted: select(state, "exhibitionReducer", "isFetchingAccepted"),
  listFilteredExhibition: select(state, "exhibitionReducer", "listFiltered"),
  profileDetail: select(state, "profileReducer", "detail"),
});

const mapDispatchToProps = (dispatch) => ({
  getAllExhibition: () => dispatch(getAllExhibition()),
  getAllExhibitionByProfileId: (id) => dispatch(getAllExhibitionByProfileId(id)),
  getFilteredExhibition: (page, pageSize, payload) => dispatch(getFilteredExhibition(page, pageSize, payload)),
  exportExhibition: (payload) => dispatch(exportExhibition(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(toJs(ExhibitionButton));

